import { useQuery } from '@tanstack/react-query';
import { customersService } from '../services';

/**
 * Hook para buscar clientes (customers) no formato dropdown (id + name).
 * Usa a rota `/customers/dropdown` (sem `permissionMiddleware`) — consumida
 * pelo Select de vínculo cliente↔projeto (Plano C, Task 6).
 *
 * A rota só existe no backend a partir da Task 2 do Plano C: até lá, a query
 * falha com 404 (transitório, inofensivo — `data` fica `undefined` e os
 * consumidores tratam com `?? []`).
 */
export const useCustomersDropdown = (options?: { enabled?: boolean; search?: string }) => {
  return useQuery({
    queryKey: ['customers', 'dropdown', options?.search],
    queryFn: () => customersService.getDropdown(options?.search),
    enabled: options?.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    // A rota só existe a partir da Task 2 do Plano C — evita retry em loop
    // enquanto o 404 transitório mencionado no header do arquivo ainda
    // pudesse ocorrer, e evita martelar o backend em erros persistentes
    // (ex: permissão), já que os consumidores tratam `data` undefined com `?? []`.
    retry: false,
  });
};
